/* Collections page in as you scroll, the way the app's collection list does, instead
   of asking for a tap. Coming back from a product restores the pages you had loaded
   and where you were, which a plain link-paginated page cannot do. */

(function () {
  var STATE_KEY = 'gettmi:collection-scroll:v1';
  var STATE_TTL = 30 * 60 * 1000;
  var MAX_RESTORE_PAGES = 12;

  var grid = document.getElementById('product-grid');
  var pager = document.querySelector('.pagination-wrapper');
  if (!grid || !pager) return;

  var nextUrl = readNextUrl(document);
  var loading = false;
  var pagesLoaded = 1;
  var sentinel = null;
  var spinner = null;

  function readNextUrl(scope) {
    var link = scope.querySelector('.pagination-wrapper a.pagination__item--prev[href]');
    return link ? link.getAttribute('href') : '';
  }

  function seenHandles() {
    var seen = {};
    grid.querySelectorAll('[data-gettmi-heart][data-handle]').forEach(function (heart) {
      seen[heart.dataset.handle] = true;
    });
    return seen;
  }

  function build() {
    /* The tap targets stay in the DOM for anyone without JavaScript, just out of view. */
    pager.hidden = true;

    spinner = document.createElement('div');
    spinner.className = 'gettmi-collection-more';
    spinner.hidden = true;
    spinner.innerHTML = '<span class="gettmi-collection-more__dot"></span>';

    sentinel = document.createElement('div');
    sentinel.className = 'gettmi-collection-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');

    pager.parentNode.insertBefore(spinner, pager);
    pager.parentNode.insertBefore(sentinel, pager);
  }

  function appendFrom(markup) {
    var parsed = new DOMParser().parseFromString(markup, 'text/html');
    var incoming = parsed.getElementById('product-grid');
    if (!incoming) return 0;
    var seen = seenHandles();
    var added = 0;
    Array.prototype.forEach.call(incoming.children, function (item) {
      var heart = item.querySelector('[data-gettmi-heart][data-handle]');
      /* The same product can appear on two pages when the catalogue shifts underneath. */
      if (heart && seen[heart.dataset.handle]) return;
      grid.appendChild(document.importNode(item, true));
      added += 1;
    });
    nextUrl = readNextUrl(parsed);
    if (window.GettmiFavourites && window.GettmiFavourites.paint) window.GettmiFavourites.paint();
    return added;
  }

  function loadNext() {
    if (loading || !nextUrl) return Promise.resolve(false);
    loading = true;
    spinner.hidden = false;
    var target = nextUrl;
    return window.fetch(target, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('page unavailable');
        return response.text();
      })
      .then(function (markup) {
        appendFrom(markup);
        pagesLoaded += 1;
        remember();
        return true;
      })
      .catch(function () {
        /* Put the buttons back rather than stranding anyone mid-catalogue. */
        nextUrl = '';
        pager.hidden = false;
        return false;
      })
      .finally(function () {
        loading = false;
        spinner.hidden = true;
        if (!nextUrl && sentinel) sentinel.remove();
      });
  }

  function remember() {
    try {
      window.sessionStorage.setItem(STATE_KEY, JSON.stringify({
        path: window.location.pathname + window.location.search,
        pages: pagesLoaded,
        scroll: window.scrollY,
        at: Date.now()
      }));
    } catch (error) {
      /* Restoring is a courtesy, never a requirement. */
    }
  }

  function storedState() {
    try {
      var raw = window.sessionStorage.getItem(STATE_KEY);
      if (!raw) return null;
      var state = JSON.parse(raw);
      var samePage = state.path === window.location.pathname + window.location.search;
      if (!samePage || Date.now() - state.at > STATE_TTL) return null;
      return state;
    } catch (error) {
      return null;
    }
  }

  function restore(state) {
    var wanted = Math.min(state.pages, MAX_RESTORE_PAGES);
    function step() {
      if (pagesLoaded >= wanted || !nextUrl) {
        window.scrollTo(0, state.scroll);
        return;
      }
      loadNext().then(function (ok) {
        if (ok) step();
        else window.scrollTo(0, state.scroll);
      });
    }
    step();
  }

  build();

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) loadNext();
    }, { rootMargin: '600px 0px' }).observe(sentinel);
  } else {
    pager.hidden = false;
  }

  window.addEventListener('scroll', function () {
    if (pagesLoaded > 1) remember();
  }, { passive: true });

  var previous = storedState();
  if (previous && previous.pages > 1) restore(previous);
})();
